import { API_URL } from '../config.js'
import { parseApiTime } from './polish-time.js'

// /api/v1/splits/{alias}: runners, markers (tylko z międzyczasami), splits, categories. API trzyma ją w cache 15 s.
export async function fetchSplits (eventAlias) {
  const response = await fetch(`${API_URL}/api/v1/splits/${encodeURIComponent(eventAlias)}`)
  if (!response.ok) throw new Error(`HTTP ${response.status}`)
  const data = await response.json()
  return {
    runners: data.runners || [],
    markers: data.markers || [],
    splits: data.splits || [],
    categories: data.categories || []
  }
}

// /api/v1/events/alias/{alias} → { event, markers, maps }: id (pokój websocketu), nazwa i start wydarzenia.
export async function fetchEventInfo (eventAlias) {
  const response = await fetch(`${API_URL}/api/v1/events/alias/${encodeURIComponent(eventAlias)}`)
  if (!response.ok) throw new Error(`HTTP ${response.status}`)
  const data = await response.json()
  const event = data.event || data
  return {
    id: event.id,
    name: event.name || eventAlias,
    startMs: parseApiTime(event.date_start),
    endMs: parseApiTime(event.date_end)
  }
}
